import { FC, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import * as api from '../../../../../../api/generated';
import * as components from '../../../../../../components';
import { TerminalImageType } from '../../../../../../enums';

export interface ITerminalImagesPreviewModel {
    locale: string | null;
    imagePreview_MainWindow: string | null;
    imagePreview_LowerLevelServicesWindow: string | null;
    imagePreview_RegistrationWindow: string | null;
    imagePreview_AdditionalIdentificationServiceWindow: string | null;
}

interface IProps {
    terminalId: number;
    terminalImagesPreviewModel: ITerminalImagesPreviewModel | null | undefined;
    fetchData: Function;
}

const DeviceTerminalImagesEdit: FC<IProps> = ({ terminalId, terminalImagesPreviewModel, fetchData }) => {
    const [mainWindowImagePreview, setMainWindowImagePreview] = useState<string | null>('');
    const [lowerLevelServicesWindowImagePreview, setLowerLevelServicesWindowImagePreview] = useState<string | null>('');
    const [registrationWindowImagePreview, setRegistrationWindowImagePreview] = useState<string | null>('');
    const [additionalIdentificationServiceWindowImagePreview, setAdditionalIdentificationServiceWindowImagePreview] = useState<string | null>('');

    useEffect(() => {
        setMainWindowImagePreview(terminalImagesPreviewModel!.imagePreview_MainWindow);
        setLowerLevelServicesWindowImagePreview(terminalImagesPreviewModel!.imagePreview_LowerLevelServicesWindow);
        setRegistrationWindowImagePreview(terminalImagesPreviewModel!.imagePreview_RegistrationWindow);
        setAdditionalIdentificationServiceWindowImagePreview(terminalImagesPreviewModel!.imagePreview_AdditionalIdentificationServiceWindow);
    }, []);

    const handleImageSubmit = async (file: File, terminalImageType: TerminalImageType, terminalId: number) => {
        try {
            await api.administration.saveTerminalImage({
                file: file ?? new File([], ''),
                id: terminalId,
                locale: terminalImagesPreviewModel?.locale ?? '',
                terminalImageType: terminalImageType
            });
            toast.success('Paveikslėlis sėkmingai išsaugotas');
            fetchData();
        } catch (ex) {
            toast.error('Paveikslėlio išsaugoti nepavyko');
        }
    };
    return (
        <>
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg4">
                    {mainWindowImagePreview != '' && (
                        <components.ImageInput
                            inputKey={1}
                            label="Pagrindinis langas:"
                            imagePreview={mainWindowImagePreview}
                            setImagePreview={(result: string) => setMainWindowImagePreview(result)}
                            onChange={async (response: File | null) => await handleImageSubmit(response!, 1, terminalId)}
                        />
                    )}
                </div>
                <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg4">
                    {lowerLevelServicesWindowImagePreview != '' && (
                        <components.ImageInput
                            inputKey={2}
                            label="Vaikinių paslaugų langas:"
                            imagePreview={lowerLevelServicesWindowImagePreview}
                            setImagePreview={(result: string) => setLowerLevelServicesWindowImagePreview(result)}
                            onChange={async (response: File | null) => await handleImageSubmit(response!, 2, terminalId)}
                        />
                    )}
                </div>
                <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg4">
                    {registrationWindowImagePreview != '' && (
                        <components.ImageInput
                            inputKey={3}
                            label={`"Turiu registraciją" langas:`}
                            imagePreview={registrationWindowImagePreview}
                            setImagePreview={(result: string) => setRegistrationWindowImagePreview(result)}
                            onChange={async (response: File | null) => await handleImageSubmit(response!, 3, terminalId)}
                        />
                    )}
                </div>
            </div>
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg4">
                    {additionalIdentificationServiceWindowImagePreview != '' && (
                        <components.ImageInput
                            inputKey={7}
                            label="Papildomos paslaugų identifikacijos langas:"
                            imagePreview={additionalIdentificationServiceWindowImagePreview}
                            setImagePreview={(result: string) => setAdditionalIdentificationServiceWindowImagePreview(result)}
                            onChange={async (response: File | null) => await handleImageSubmit(response!, 7, terminalId)}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

export default DeviceTerminalImagesEdit;
